import { render, staticRenderFns } from "./BatchRunStatus.vue?vue&type=template&id=46dfdd41&scoped=true"
import script from "./BatchRunStatus.vue?vue&type=script&lang=js"
export * from "./BatchRunStatus.vue?vue&type=script&lang=js"
import style0 from "./BatchRunStatus.vue?vue&type=style&index=0&id=46dfdd41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dfdd41",
  null
  
)

/* custom blocks */
import block0 from "@/components/PBatchRun/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FPBatchRun%2FBatchRun%2FBatchRunStatus.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports